import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ApiVisa, BaseApiTemplateService, BasicApiResponseModel, Core2Config, Pagination, PagingResponseModel } from '../shared';
import { MerchantTxnReportContainerModel } from '../../../../../models/aggregates/pgw/merchant-txn-report.model';
import { MerchantTxnReportCriteriaModelQuery, MerchantTxnReportQueryCriteriaClass } from '../../criteria/pgw/merchant-txn-report-criteria.model';

@Injectable({
  providedIn: 'root',
})
export class MerchantTxnReportService extends BaseApiTemplateService<MerchantTxnReportContainerModel> {

  protected readonly summaryUrl: string = `${ Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.PGW_PREFIX }txn-merchant-summary`;
  
  constructor(http: HttpClient) {
    super();
    
    this.httpClient = http;
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.PGW_PREFIX + 'merchant-monthly-reports';
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.PGW_PREFIX + 'merchant-monthly-reports';
  }

  public getMercahntTxnReportByCriteria(visa: ApiVisa, criteria?: MerchantTxnReportQueryCriteriaClass): Observable<PagingResponseModel<MerchantTxnReportContainerModel>> {
    if (this.endpoint_path && visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + this.endpoint_path;
    }

    const buildMerchantTxnReportCriteria = new MerchantTxnReportCriteriaModelQuery(criteria);
    return this.httpClient.get<PagingResponseModel<MerchantTxnReportContainerModel>>(this.apiUrl + '/query?' + buildMerchantTxnReportCriteria.query, this.getHttpHeader(visa));
  }

  public downloadMerchantSummary(type: 'internal' | 'external', guid: string, visa: ApiVisa): Observable<any>{
    return this.httpClient.post<any>(`${ visa.api_domain_url }core2/tnt/dm/pgw/txn-merchant-attachment/${ type === 'external'? 'merchant-' : '' }file/${ guid }`, null, <any> { ...this.getHttpHeader(visa), responseType: 'blob' }); 
  }

  public getMerchantSummary(type: 'internal' | 'external', pagination: Pagination, visa: ApiVisa): Observable<PagingResponseModel<any>>{
    return this.httpClient.get<PagingResponseModel<any>>(`${ visa.api_domain_url }${ this.summaryUrl }/${ type === 'internal'? 'backoffice-ep/' : '' }query?${ pagination.getQueryKeyValues() }`, this.getHttpHeader(visa));
  }

  public getMerchantSummaryAudit(guid: string, pagination: Pagination, visa: ApiVisa): Observable<PagingResponseModel<any>>{
    return this.httpClient.get<PagingResponseModel<any>>(`${ visa.api_domain_url }${ Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.PGW_PREFIX }txn-merchant-event/query?hdr_guid=${ guid }&${ pagination.getQueryKeyValues() }`, this.getHttpHeader(visa));
  }

  public getMerchantSummaryDetail(type: 'internal' | 'external', pagination: Pagination, visa: ApiVisa): Observable<PagingResponseModel<any>>{
    return this.httpClient.get<PagingResponseModel<any>>(`${ visa.api_domain_url }${ this.summaryUrl }-detail/${ type === 'internal'? 'backoffice-ep/' : '' }query?${ pagination.getQueryKeyValues() }`, this.getHttpHeader(visa));
  }

  public setSummaryPaidStatus(guid: string, visa: ApiVisa): Observable<BasicApiResponseModel<any>>{
    return this.httpClient.put<BasicApiResponseModel<any>>(`${ visa.api_domain_url }${ this.summaryUrl }/pay-summary/${ guid }`, null, this.getHttpHeader(visa));
  }
}
